module.exports = __webpack_public_path__ + "static/media/review-img1.31f36604.jpg";